$(document).ready(function () {
    $('[data-toggle=step][data-target]').on('click', function () {
        $('[id*=step-]').addClass('d-none');
        $($(this).attr('data-target')).toggleClass('d-none');
    });

    $('[data-toggle=step-modal][data-target]').on('click', function () {
        $('[id*=stepmodal-]').addClass('d-none');
        $($(this).attr('data-target')).toggleClass('d-none');
    });

    $('[data-toggle=reset]').on('click', function () {
        $(this).closest('form')[0].reset();
    });

    /* Date picker */
    var now = new Date();
    var nowValue = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);

    $('[data-toggle=date]')
        .val(nowValue)
        .on('click', function () {
            $(this).datepicker('show');
        }).datepicker({
            format: 'yyyy-mm-dd',
            weekStart: 1,
            startDate: nowValue,
            autoclose: true,
        });
});